// extracted by css-extract-rspack-plugin
export default {"cls1":"CreateSocialItemModal-cls1_J3X","cls2":"CreateSocialItemModal-cls2_hyQ CreateSocialItemModal-cls1_J3X"};